import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { preconnectToCheckout } from "./utils/preconnect";

// Before React mounts: warm the connection to the checkout origin.
preconnectToCheckout();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-204" data-mp="26alqainc4lzl" />);
}